export const TesEmployeesListingMutations = {
  SetTesEmployeesList: 'setTesEmployeesListingList',
  SetTesEmployeesLoading: 'setTesEmployeesListingLoading',
  SetTesEmployeesSortOrder: 'setTesEmployeesListingSortOrder',
  SetTesEmployeesPaginationParameters: 'setTesEmployeesListingPaginationParameters',
  ResetTesEmployeesPaginationOffset: 'resetTesEmployeesListingPaginationOffset',
  SetTesEmployeesRecordCount: 'setTesEmployeesListingRecordCount',
  SetTesEmployeesActiveInactive: 'setTesEmployeesListingActiveInactive',
  SetSearchParam: 'TesEmployeesListingMutations.SetSearchParam'
};

export const TesEmployeesListingGetters = {
  TesEmployeesList: 'getTesEmployeesListingList',
  SortBy: 'getTesEmployeesListingSortBy ',
  SortDirection: 'getTesEmployeesListingSortDirection',
  TesEmployeesPerPage: 'getTesEmployeesListingPerPage',
  TesEmployeesListingOffset: 'getTesEmployeesListingOffset',
  TesEmployeesRecordCount: 'getTesEmployeesListingRecordCount',
  TesEmployeesActiveInactive: 'getTesEmployeesListingActiveInactive'
};

export const TesEmployeesListingActions = {
  RetrieveTesEmployees: 'retrieveTesEmployeesListing',
  SetTesEmployeesSortOrder: 'updateTesEmployeesListingSortOrder',
  SetTesEmployeesPaginationParameters: 'updateTesEmployeesListingPaginationParameters',
  SetTesEmployeesActiveInactive: 'updateTesEmployeesListingActiveInactive',
  RetrieveTesEmployeesRecordCount: 'updateTesEmployeesListingRecordCount',
  ExportCurrentPageTesEmployeesAsExcel: 'exportCurrentPageTesEmployees',
  ExportAllTesEmployeesAsExcel: 'exportAllTesEmployees',
  UpdateSearchList: 'TesEmployeesListingActions.UpdateSearchList'
};
